import { useEffect, useState } from "react";
import { AnunciosData } from '../../types/Anuncio/AnuncioData';
import { useNavigate } from "react-router-dom";
import { Area } from '../../types/Area/Area';
import { useFormik } from "formik";
import { Audiencia } from '../../types/Audiencia/Audiencia';
import { Categoria } from "../../types/Categoria/Categoria";
import { Alert, Autocomplete, Box, Button, Checkbox, CircularProgress, Collapse, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, FormGroup, FormLabel, Grid, IconButton, InputAdornment, InputLabel, MenuItem, Radio, RadioGroup, Select, SelectChangeEvent, Switch, TextField, Tooltip, tooltipClasses, Typography } from "@mui/material";
import AnuncioService from "../../services/AnuncioService";
import AreaService from '../../services/AreaService';
import CategoriasService from '../../services/CategoriasService';
import AudienciaService from "../../services/AudienciaService";
import AriService from "../../services/AriService";
import { useAppSelector } from "../../redux/hooks";
import { AnuncioValidationSchema } from "../validationsForm/ValidationAnuncioForm";
import SweetAlertUtil from "../../utils/SweetAlert";
import { textDateFormat } from "../../utils/dateFormat";
import ImagePreviewer from "../../common/Behelit/ImagePreview";
import { FaMap } from "react-icons/fa";
import { InfoMapa } from "../Creador/InfoMapa";
import TipoEventosService from "../../services/TipoEventoService";
import { TipoEvento } from "../../types/TipoEvento/TipoEvento";
import { Tematica } from "../../types/Tematica/Tematica";
import TematicaService from "../../services/TematicaService";
import { Campus } from "../../types/UbicacionesAri/Campus";
import { Zona } from "../../types/UbicacionesAri/Zona";
import { Bloque } from "../../types/UbicacionesAri/Bloque";
import { Ubicacion } from "../../types/UbicacionesAri/Ubicacion";
import { TipoUbicacion } from "../../types/UbicacionesAri/TipoUbicacion";
import { FacultadPalette, InstitucionalPalette } from "../../config/theme.config";
import AcadService from "../../services/AcadService";
import { Facultad } from "../../types/Academico/Facultad";
import PostgradoService from "../../services/PostgradoService";
import { FacultadPos } from "../../types/Postgrado/Postgrado";
import { Iconify } from "../../common/iconify";

const enlace = 'https://www.google.com/maps/place/Escuela+Superior+Polit%C3%A9cnica+del+Litoral+(ESPOL)/@-2.1478748,-79.9671443,17z/data=!4m14!1m7!3m6!1s0x902d72f925e5bfdb:0x327cdb9f7f4ba3b2!2sEscuela+Superior+Polit%C3%A9cnica+del+Litoral+(ESPOL)!8m2!3d-2.1478802!4d-79.9645694!16s%2Fm%2F0g9w797!3m5!1s0x902d72f925e5bfdb:0x327cdb9f7f4ba3b2!8m2!3d-2.1478802!4d-79.9645694!16s%2Fm%2F0g9w797?entry=ttu&g_ep=EgoyMDI0MTIwNC4wIKXMDSoASAFQAw%3D%3D'

interface Props {
  anuncio: AnunciosData;
  onResponse?: (dataRespuesta: any) => void

}

export const FormAnuncio: React.FC<Props> = ({ anuncio }) => {
  const navigate = useNavigate();  // Hook de React Router v6
  const { userData } = useAppSelector((state) => state.authReducer)
  const [area, setArea] = useState<Array<Area>>([]);
  const [categoria, setCategoria] = useState<Array<Categoria>>([]);
  const [audiencia, setAudiencia] = useState<Array<Audiencia>>([]);
  const [carrerasGrado, setCarrerasGrado] = useState<Array<Facultad>>([]);
  const [carrerasPostGrado, setCarrerasPostGrado] = useState<Array<FacultadPos>>([]);
  const [tipoEvento, setTipoEvento] = useState<Array<TipoEvento>>([]);
  const [tags, setTags] = useState<Array<Tematica>>([]);
  const [campus, setCampus] = useState<Array<Campus>>([]);
  const [zonas, setZonas] = useState<Array<Zona>>([]);
  const [bloques, setBloques] = useState<Array<Bloque>>([]);
  const [tiposUbicaciones, setTiposUbicaciones] = useState<Array<TipoUbicacion>>([]);
  const [ubicaciones, setUbicaciones] = useState<Array<Ubicacion>>([]);
  const [ready, setReady] = useState(true);
  const [openMap, setOpenMap] = useState(false);
  const [audienciasCollapse, setAudienciasCollapse] = useState<Array<number>>([]);
  const [gradoCollapse, setGradoCollapse] = useState<Array<number>>([]);
  const [postgradoCollapse, setPostgradoCollapse] = useState<Array<number>>([]);

  const toggleAudienciaCollapse = (id: number) => {
    setAudienciasCollapse((prev) =>
      prev.includes(id)
        ? prev.filter((item) => item !== id) // si ya existe → lo quita
        : [...prev, id]                      // si no existe → lo agrega
    );
  };
  const toggleGradoCollapse = (id: number) => {
    setGradoCollapse((prev) =>
      prev.includes(id)
        ? prev.filter((item) => item !== id) // si ya existe → lo quita
        : [...prev, id]                      // si no existe → lo agrega
    );
  };
  const togglePostgradoCollapse = (id: number) => {
    setPostgradoCollapse((prev) =>
      prev.includes(id)
        ? prev.filter((item) => item !== id) // si ya existe → lo quita
        : [...prev, id]                      // si no existe → lo agrega
    );
  };
  const getCampus = async () => {
    await AriService.GetListaCampus().then((data) => {
      const idsValidos = [1, 2, 1092];
      setCampus(data.filter(x => idsValidos.includes(x.idlugarespol)));
    }).catch((error) => console.error(error));
  }
  const getZonas = async (id: number) => {
    await AriService.GetListaZonas(id).then((data) => {
      //console.log(data)
      setZonas(data)
    }).catch((error) => console.error(error));
  }
  const getBloques = async (id: number) => {
    await AriService.GetListaBloques(id, [1]).then((data) => {
      //console.log(data)
      setBloques(data)
    }).catch((error) => console.error(error));
  }
  const getTipoUbicaciones = async (id: number) => {
    await AriService.GetListaTipoUbicacion(id, 'TE').then((data) => {
      //console.log(data)
      let idsTipos = [39, 51, 58, 60, 63, 64, 127, 128, 136]
      let tipos = data.filter(x => idsTipos.includes(x.idifgrupotipo));
      setTiposUbicaciones(tipos)
    }).catch((error) => console.error(error));
  }
  const getUbicaciones = async (id: number, idTipo?: number) => {
    if (idTipo !== undefined && idTipo != 0) {
      await AriService.GetListaUbicacion(id, idTipo).then((data) => {
        //console.log(data)
        setUbicaciones(data)
      }).catch((error) => console.error(error));
    } else {
      await AriService.GetListaUbicacion(id).then((data) => {
        //console.log(data)
        setUbicaciones(data)
      }).catch((error) => console.error(error));
    }

  }
  const getCategorias = async () => {
    await CategoriasService.GetCategoriasActivas().then((data) => {
      //console.log(data)
      if (data.status.isSuccessfully) {
        setCategoria(data.listData);
      }
    }).catch((error) => console.error(error));
  }
  const getCarrerasGrado = async () => {
    await AcadService.ConsultaCarrerasActivas().then((data) => {
      //console.log(data)
      if (data.status.isSuccessfully) {
        setCarrerasGrado(data.listData.filter(x => x.listaProgramas.length > 0).sort((a, b) =>
          a.nombreFacultad.localeCompare(b.nombreFacultad)
        ));
      }
    }).catch((error) => console.error(error));
  }
  const getCarrerasPostGrado = async () => {
    await PostgradoService.ConsultaCarrerasProgramas('P').then((data) => {
      //console.log(data)
      if (data.status.isSuccessfully) {
        setCarrerasPostGrado(data.listData.filter(x => x.lProgramas.length > 0));
      }
    }).catch((error) => console.error(error));
  }
  const getTags = async () => {
    await TematicaService.GetTematicasActivas().then((data) => {
      if (data.status.isSuccessfully) {
        setTags(data.listData);
      }
    }).catch((error) => console.error(error));
  }
  const getTipoEventos = async () => {
    await TipoEventosService.GetTipoEventosActivos()
      .then((data) => {
        //console.log(data)
        if (data.status.isSuccessfully) {
          setTipoEvento(data.listData);
        } else {
          setTipoEvento([]);
        }
      }).catch((error) => console.error(error));
  }
  const getAreas = async (user: string) => {
    setReady(false);
    try {
      const areas = await AreaService.GetAreas();
      // console.log(areas)
      const indices: number[] = await AreaService.GetAreasGestorbyUsername(user);
      // console.log(indices)
      const areasUsuario = areas.filter((area) => indices.includes(area.idArea));
      // console.log(areasUsuario);
      setArea(areasUsuario)
    } catch (error) {
      console.error("Error al obtener las áreas del usuario:", error);
      return [];
    } finally {
      setReady(true);
    }
  }
  const handleOpen = () => {
    setOpenMap(true);
  }
  const handleClose = () => {
    setOpenMap(false);
  }
  const handleOpenLink = (link: string) => {
    window.open(link, '_blank', 'noopener,noreferrer');
  };
  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = event.target;

    // Si el checkbox se selecciona, actualizamos dtPublicacion a la fecha actual
    if (checked) {
      const currentDate = new Date().toISOString().split('T')[0]; // Formato YYYY-MM-DD
      formik.setFieldValue('dtPublicacion', currentDate); // Establece la fecha actual
    } else {
      formik.setFieldValue('dtPublicacion', ''); // Borra la fecha si no está seleccionado
    }

    // Actualiza el valor de bdPublicarAutomatico
    formik.setFieldValue('bdPublicarAutomatico', checked);
  };
  const getAudiencia = async () => {
    await AudienciaService.GetAudiencias().then((data) => {
      setAudiencia(data.sort((a, b) => a.txNombre.localeCompare(b.txNombre)));
    }).catch((error) => console.error(error));
  }
  const handleSwitchChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    const isChecked = event.target.checked;
    if (isChecked) {
      // Agrega el valor si no está
      if (!formik.values.audiencias.includes(17)) {
        formik.setFieldValue("audiencias", [17]);
        formik.setFieldValue("facultadesGrado", []);
        formik.setFieldValue("programasGrado", []);
        formik.setFieldValue("facultadesPostGrado", []);
        formik.setFieldValue("programasPostGrado", []);
      }
    } else {
      // Quita el valor si se apaga
      formik.setFieldValue(
        "audiencias",
        formik.values.audiencias.filter((a) => a !== 17)
      );
    }
  };
  const handleParentChange = (padre: any, checked: boolean, hijos: Array<Audiencia>) => {
    let updated = [...formik.values.audiencias];
    // Manejo de audiencias normales
    if (![3, 6].includes(padre.idAudiencia)) {
      if (checked) {
        updated.push(padre.idAudiencia);
        hijos.forEach((h) => {
          if (!updated.includes(h.idAudiencia)) updated.push(h.idAudiencia);
        });
      } else {
        updated = updated.filter(
          (id) => id !== padre.idAudiencia && !hijos.some((h) => h.idAudiencia === id)
        );
      }
      formik.setFieldValue("audiencias", updated);
      return;
    }
    // Manejo especial para Grado (3) y Postgrado (6)
    if (checked) {
      // Agregar el propio padre
      if (!updated.includes(padre.idAudiencia)) updated.push(padre.idAudiencia);

      if (padre.idAudiencia === 3) {
        // Grado
        const facultadesIds = carrerasGrado.map((f) => f.idUnidad);
        const programasIds = carrerasGrado.flatMap((f) =>
          f.listaProgramas.map((p) => `${f.idUnidad}-${p.idPrograma}`)
        );
        formik.setFieldValue("facultadesGrado", facultadesIds);
        formik.setFieldValue("programasGrado", programasIds);
      }
      if (padre.idAudiencia === 6) {
        // Postgrado
        const facultadesIds = carrerasPostGrado.map((f) => f.idUnidad);
        const programasIds = carrerasPostGrado.flatMap((f) =>
          f.lProgramas.map((p) => `${f.idUnidad}-${p.id}`)
        );
        formik.setFieldValue("facultadesPostGrado", facultadesIds);
        formik.setFieldValue("programasPostGrado", programasIds);
      }
    } else {
      // Desmarcar padre 3 o 6 → limpiar todo
      updated = updated.filter((id) => id !== padre.idAudiencia);
      if (padre.idAudiencia === 3) {
        formik.setFieldValue("facultadesGrado", []);
        formik.setFieldValue("programasGrado", []);
      }
      if (padre.idAudiencia === 6) {
        formik.setFieldValue("facultadesPostGrado", []);
        formik.setFieldValue("programasPostGrado", []);
      }
    }
    formik.setFieldValue("audiencias", updated);
  };
  const handleChildChange = (childId: number, checked: boolean, padreId: number, hijos: Array<Audiencia>) => {
    let updated = [...formik.values.audiencias];

    if (checked) {
      // Agrega el hijo
      if (!updated.includes(childId)) updated.push(childId);

      // Si quieres, también podrías marcar al padre automáticamente cuando se selecciona al menos un hijo
      if (!updated.includes(padreId)) updated.push(padreId);
    } else {
      // Quita el hijo
      updated = updated.filter((id) => id !== childId);

      // Revisar si quedan hijos seleccionados
      const algunHijoSeleccionado = hijos.some((h) => updated.includes(h.idAudiencia));

      if (!algunHijoSeleccionado) {
        // Si no queda ningún hijo seleccionado, quitar al padre
        updated = updated.filter((id) => id !== padreId);
      }
    }

    formik.setFieldValue("audiencias", updated);
  };
  const handleChildFacultadChange = (childId: number, checked: boolean) => {
    let updatedFacultades = [...formik.values.facultadesGrado];
    let updatedProgramas = [...formik.values.programasGrado];

    const facultad = carrerasGrado.find((x) => x.idUnidad === childId);
    const programasIds = facultad?.listaProgramas.map((p) => `${childId}-${p.idPrograma}`) ?? [];

    if (checked) {
      // Agregar facultad y todos sus programas
      updatedFacultades = Array.from(new Set([...updatedFacultades, childId]));
      updatedProgramas = Array.from(new Set([...updatedProgramas, ...programasIds]));
    } else {
      // Quitar facultad y todos sus programas
      updatedFacultades = updatedFacultades.filter((id) => id !== childId);
      updatedProgramas = updatedProgramas.filter((id) => !programasIds.includes(id));
    }
    console.log('check facultad')
    formik.setFieldValue("facultadesGrado", updatedFacultades);
    formik.setFieldValue("programasGrado", updatedProgramas);
  };
  const handleChildFacultadPosChange = (childId: number, checked: boolean) => {
    let updatedFacultades = [...formik.values.facultadesPostGrado];
    let updatedProgramas = [...formik.values.programasPostGrado];

    const facultad = carrerasPostGrado.find((x) => x.idUnidad === childId);
    const programasIds = facultad?.lProgramas.map((p) => `${childId}-${p.id}`) ?? [];

    if (checked) {
      updatedFacultades = Array.from(new Set([...updatedFacultades, childId]));
      updatedProgramas = Array.from(new Set([...updatedProgramas, ...programasIds]));
    } else {
      updatedFacultades = updatedFacultades.filter((id) => id !== childId);
      updatedProgramas = updatedProgramas.filter((id) => !programasIds.includes(id));
    }

    formik.setFieldValue("facultadesPostGrado", updatedFacultades);
    formik.setFieldValue("programasPostGrado", updatedProgramas);
  };
  const handleChildProgramaGradoChange = (childId: string, checked: boolean) => {
    let updatedProgramas = [...formik.values.programasGrado];

    if (checked) {
      updatedProgramas.push(childId);
    } else {
      updatedProgramas = updatedProgramas.filter((id) => id !== childId);
    }

    // Actualizar facultad correspondiente
    const [facIdStr] = childId.split("-");
    const facId = parseInt(facIdStr);
    const facultad = carrerasGrado.find((f) => f.idUnidad === facId);
    const programasIds = facultad?.listaProgramas.map((p) => `${facId}-${p.idPrograma}`) ?? [];

    let updatedFacultades = [...formik.values.facultadesGrado];

    const allSelected = programasIds.every((pId) => updatedProgramas.includes(pId));
    const someSelected = programasIds.some((pId) => updatedProgramas.includes(pId));

    if (allSelected) {
      if (!updatedFacultades.includes(facId)) updatedFacultades.push(facId);
    } else if (!someSelected) {
      updatedFacultades = updatedFacultades.filter((id) => id !== facId);
    }

    formik.setFieldValue("programasGrado", updatedProgramas);
    formik.setFieldValue("facultadesGrado", updatedFacultades);
  };
  const handleChildProgramaPostGradoChange = (childId: string, checked: boolean) => {
    let updatedProgramas = [...formik.values.programasPostGrado];

    if (checked) {
      updatedProgramas.push(childId);
    } else {
      updatedProgramas = updatedProgramas.filter((id) => id !== childId);
    }

    const [facIdStr] = childId.split("-");
    const facId = parseInt(facIdStr);
    const facultad = carrerasPostGrado.find((f) => f.idUnidad === facId);
    const programasIds = facultad?.lProgramas.map((p) => `${facId}-${p.id}`) ?? [];

    let updatedFacultades = [...formik.values.facultadesPostGrado];

    const allSelected = programasIds.every((pId) => updatedProgramas.includes(pId));
    const someSelected = programasIds.some((pId) => updatedProgramas.includes(pId));

    if (allSelected) {
      if (!updatedFacultades.includes(facId)) updatedFacultades.push(facId);
    } else if (!someSelected) {
      updatedFacultades = updatedFacultades.filter((id) => id !== facId);
    }

    formik.setFieldValue("programasPostGrado", updatedProgramas);
    formik.setFieldValue("facultadesPostGrado", updatedFacultades);
  };
  const formik = useFormik<AnunciosData>({
    initialValues: {
      ...anuncio,
      bdTipo: anuncio.bdTipo === '' ? 'E' : anuncio.bdTipo,
      bdAmbito: anuncio.bdAmbito === '' ? 'A' : anuncio.bdAmbito,
    },
    validationSchema: AnuncioValidationSchema,
    onSubmit: (values) => {
      console.log(values)
      if (values.bdTipo !== "E") {
        values.dtInicio = '';
        values.dtFin = '';
        values.txLugar = '';
        values.txtUrlMaps = '';
        values.estadoMiEspol = 'I'
        values.ImagenCaratula = null;
        values.idTipoEvento = 0;
      } else {
        values.estadoMiEspol = 'A';
      }
      values.softDeleted = false;
      //values.dtEnvio = DateTime.now().toString();
      if (values.idAnuncio === 0) {
        guardar(values)
      } else {
        actualizar(values)
      }
    }
  });
  const guardar = (data: AnunciosData) => {
    AnuncioService.CreateAnuncio(data)
      .then((res) => {
        if (res.status.isSuccessfully) {
          // Mostrar SweetAlert de éxito
          SweetAlertUtil.alertaExito('Exito', data.bdEstado === 'B' ? 'El anuncio se ha guardado correctamente.' : 'El anuncio se ha enviado correctamente.');
          setTimeout(() => {
            navigate('/creator/misComunicados');
          }, 3000);
        } else {
          // Mostrar SweetAlert de error
          SweetAlertUtil.alertaAdvertencia('Alerta!', 'Hubo un error al guardar la información.')
        }
      })
      .catch((err) => {
        //console.error(err)
        SweetAlertUtil.alertaAdvertencia('¡Error!', 'Hubo un problema al conectar con el servidor.')
      });
  }
  const actualizar = (data: AnunciosData) => {
    AnuncioService.UpdateAnuncio(data)
      .then((res) => {
        if (res.status.isSuccessfully) {
          SweetAlertUtil.alertaExito('Exito', data.bdEstado === 'B' ? 'El anuncio se ha guardado correctamente.' : 'El anuncio se ha actualizado correctamente.');
          setTimeout(() => {
            navigate('/creator/misComunicados');
          }, 3000);
        } else {
          SweetAlertUtil.alertaAdvertencia('Alerta!', 'Hubo un error al actualizar la información.')
        }
      })
      .catch((err) => {
        //console.error(err)
        SweetAlertUtil.alertaAdvertencia('¡Error!', 'Hubo un problema al conectar con el servidor.')
      });
  }
  useEffect(() => {
    getCategorias();
    getAreas(userData?.usuario ?? '');
    getAudiencia();
    getTipoEventos();
    getTags();
    getCampus();
    getCarrerasGrado();
    getCarrerasPostGrado();
  }, [userData?.usuario]);

  useEffect(() => {
    if (anuncio?.audiencias && audiencia?.length) {
      const seleccionadas = [...anuncio.audiencias];

      // 1️⃣ Buscar los padres que tengan al menos un hijo seleccionado
      const padresConHijosSeleccionados = audiencia
        .filter(
          (a) =>
            a.idAudienciaPadre !== null &&
            seleccionadas.includes(a.idAudiencia)
        )
        .map((a) => a.idAudienciaPadre);

      // 2️⃣ Eliminamos duplicados
      const unicos = Array.from(new Set(padresConHijosSeleccionados));

      // 3️⃣ Actualizamos el estado
      setAudienciasCollapse(unicos);
    }
  }, [anuncio.audiencias, audiencia]);

  useEffect(() => {
    if (anuncio?.facultadesGrado && anuncio.facultadesGrado.length > 0) {
      setAudienciasCollapse((prev) =>
        prev.includes(3)
          ? prev.filter((item) => item !== 3) // si ya existe → lo quita
          : [...prev, 3]                      // si no existe → lo agrega
      );
    }
  }, [anuncio.facultadesGrado]);

  useEffect(() => {
    if (formik.values.idCampus !== undefined && formik.values.idCampus > 0) {
      getZonas(formik.values.idCampus);
    } else {
      setZonas([]);
    }
  }, [formik.values.idCampus]);

  useEffect(() => {
    if (formik.values.idZona !== undefined && formik.values.idZona > 0) {
      getBloques(formik.values.idZona);
    } else {
      setBloques([]);
    }
  }, [formik.values.idZona]);

  useEffect(() => {
    if (formik.values.idBloque !== undefined && formik.values.idBloque > 0) {
      getTipoUbicaciones(formik.values.idBloque);
    } else {
      setUbicaciones([]);
    }
  }, [formik.values.idBloque]);

  useEffect(() => {
    if (formik.values.idBloque !== undefined && formik.values.idBloque > 0 && formik.values.idTipoUbicacion !== undefined && formik.values.idTipoUbicacion > 0) {
      getUbicaciones(formik.values.idBloque, formik.values.idTipoUbicacion);
    } else if (formik.values.idBloque !== undefined && formik.values.idBloque > 0) {
      getUbicaciones(formik.values.idBloque);
    } else {
      setUbicaciones([]);
    }
  }, [formik.values.idBloque, formik.values.idTipoUbicacion]);

  useEffect(() => {
    if (formik.values.idUbicacion !== undefined && formik.values.idUbicacion > 0) {
      var ubicacion = ubicaciones.find(x => x.idifsubgrupo)
      formik.setFieldValue('txtUrlMaps', ubicacion?.urlMap);
      formik.setFieldValue('txLugar', `${ubicacion?.codigo}-${ubicacion?.etiqueta}`);
    }
  }, [formik.values.idUbicacion, ubicaciones]);

  useEffect(() => {
    if (formik.values.esEnEspol) {
      formik.setFieldValue('txtUrlMaps', '');
      formik.setFieldValue('txLugar', '');
    } else {
      formik.setFieldValue('idCampus', 0);
      formik.setFieldValue('idZona', 0);
      formik.setFieldValue('idBloque', 0);
      formik.setFieldValue('idTipoUbicacion', 0);
      formik.setFieldValue('idUbicacion', 0);
      formik.setFieldValue('txLugar', '');
    }
  }, [formik.values.esEnEspol]);

  useEffect(() => {
    if (formik.values.bdTipo === 'A') {
      formik.setFieldValue('dtInicio', '');
      formik.setFieldValue('dtFin', '');
      formik.setFieldValue('idCampus', 0);
      formik.setFieldValue('idZona', 0);
      formik.setFieldValue('idBloque', 0);
      formik.setFieldValue('idTipoUbicacion', 0);
      formik.setFieldValue('idUbicacion', 0);
      formik.setFieldValue('txtUrlMaps', '');
      formik.setFieldValue('txLugar', '');
      formik.setFieldValue('txtUrlMaps', '');
      formik.setFieldValue('esEnEspol', false);
    }
  }, [formik.values.bdTipo]);

  //console.log('Errores:', formik.errors);
  if (!ready) {
    return (
      <CircularProgress />
    )
  }
  {/** Colapsa en si mismo, su mundo es exiliado*/ }
  function getFacultadColor(siglas: string) {
    return FacultadPalette[`${siglas}_PRIMARY` as keyof typeof FacultadPalette];
  }
  const HijoProdigo = (padre: any, hijos: Array<Audiencia>) => {
    let collapseContent;
    switch (padre.idAudiencia) {
      case 3:
        collapseContent = (
          <>
            <Collapse
              in={audienciasCollapse.includes(3)}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {carrerasGrado.map((fg) => (
                  <>
                    <Box
                      key={"fg-" + fg.idUnidad}
                      display="flex"
                      alignItems="center"
                      sx={{
                        border: `1px solid ${getFacultadColor(fg.siglasFacultad)}`,
                        backgroundColor: getFacultadColor(fg.siglasFacultad),
                        borderRadius: "6px",
                        padding: "4px 8px",
                        margin: "2px 0",
                        minHeight: "50px",
                      }}
                    >
                      <Checkbox
                        checked={fg.listaProgramas.every(p =>
                          formik.values.programasGrado.includes(`${fg.idUnidad}-${p.idPrograma}`)
                        )}
                        indeterminate={
                          fg.listaProgramas.some(p =>
                            formik.values.programasGrado.includes(`${fg.idUnidad}-${p.idPrograma}`)
                          ) &&
                          !fg.listaProgramas.every(p =>
                            formik.values.programasGrado.includes(`${fg.idUnidad}-${p.idPrograma}`)
                          )
                        }
                        sx={{
                          color: fg.siglasFacultad.trim() === 'FCSH' ? "#000000" : "#ffffffff",
                          "&.Mui-checked": {
                            color: fg.siglasFacultad.trim() === 'FCSH' ? "#000000" : "#ffffffff",
                          },
                          "&.MuiCheckbox-indeterminate": {
                            color: fg.siglasFacultad.trim() === 'FCSH' ? "#000000" : "#ffffffff",
                          },
                          "& .MuiSvgIcon-root": { fontSize: 28 },
                        }}
                        onChange={(e) =>
                          handleChildFacultadChange(fg.idUnidad, e.target.checked)
                        }
                      />
                      <Typography
                        sx={{
                          color: fg.siglasFacultad.trim() === 'FCSH' ? "#000000" : "#ffffffff",
                          flex: 1,                 // ocupa el espacio restante
                          textAlign: "left",       // alineación a la izquierda
                          whiteSpace: "normal",    // permite varias líneas
                          overflowWrap: "normal",  // evita cortar palabras
                        }}
                      >
                        {fg.siglasFacultad}
                      </Typography>
                      <IconButton
                        size="small"
                        onClick={() => toggleGradoCollapse(fg.idUnidad)}
                        sx={{
                          color: fg.siglasFacultad.trim() === 'FCSH' ? "#000000" : "#ffffffff",
                          transition: "transform 0.3s",
                        }}
                      >
                        {gradoCollapse.includes(fg.idUnidad) ? <Iconify icon={"ic:outline-expand-less"} width={30} sx={{ color: fg.siglasFacultad.trim() === 'FCSH' ? "#000000" : "#ffffffff" }} /> : <Iconify icon={"ic:baseline-expand-more"} width={30} sx={{ color: fg.siglasFacultad.trim() === 'FCSH' ? "#000000" : "#ffffffff" }} />}
                      </IconButton>
                    </Box>
                    <Grid sx={{ pl: 2 }}>
                      {NietoDelProdigo(fg)}
                    </Grid>
                  </>
                ))}
              </div>
            </Collapse>
          </>
        );
        break;
      case 6:
        collapseContent = (
          <>
            <Collapse
              in={audienciasCollapse.includes(6)}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {carrerasPostGrado.map((fp) => (
                  <>
                    <Box
                      key={"fp-" + fp.idUnidad}
                      display="flex"
                      alignItems="center"
                      sx={{
                        border: `1px solid ${fp.strColorUnidad}`,
                        backgroundColor: fp.strColorUnidad,
                        borderRadius: "6px",
                        padding: "4px 8px",
                        margin: "2px 0",
                        minHeight: "50px",
                      }}
                    >
                      <Checkbox
                        checked={formik.values.facultadesPostGrado.includes(
                          fp.idUnidad
                        )}
                        indeterminate={
                          fp.lProgramas.some(p =>
                            formik.values.programasPostGrado.includes(`${fp.idUnidad}-${p.id}`)
                          ) &&
                          !fp.lProgramas.every(p =>
                            formik.values.programasPostGrado.includes(`${fp.idUnidad}-${p.id}`)
                          )
                        }
                        sx={{
                          color: fp.strSiglasUnidad.trim() === 'FCSH' ? "#000000" : "#ffffffff", // color del ícono cuando no está marcado
                          "&.Mui-checked": {
                            color: fp.strSiglasUnidad.trim() === 'FCSH' ? "#000000" : "#ffffffff", // color cuando está marcado (ej: verde contraste)
                          },
                          "&.MuiCheckbox-indeterminate": {
                            color: fp.strSiglasUnidad.trim() === 'FCSH' ? "#000000" : "#ffffffff",
                          },
                          "& .MuiSvgIcon-root": {
                            fontSize: 28, // opcional, cambiar tamaño
                          },
                        }}
                        onChange={(e) =>
                          handleChildFacultadPosChange(fp.idUnidad, e.target.checked)
                        }
                      />
                      <Typography
                        sx={{
                          color: fp.strSiglasUnidad.trim() === 'FCSH' ? "#000000" : "#ffffffff",
                          flex: 1,                 // ocupa el espacio restante
                          textAlign: "left",       // alineación a la izquierda
                          whiteSpace: "normal",    // permite varias líneas
                          overflowWrap: "normal",  // evita cortar palabras
                        }}
                      >
                        {fp.strSiglasUnidad}
                      </Typography>
                      <IconButton
                        size="small"
                        onClick={() => togglePostgradoCollapse(fp.idUnidad)}
                        sx={{
                          color: fp.strSiglasUnidad.trim() === 'FCSH' ? "#000000" : "#ffffffff",
                          transition: "transform 0.3s",
                        }}
                      >
                        {postgradoCollapse.includes(fp.idUnidad) ? <Iconify icon={"ic:outline-expand-less"} width={30} sx={{ color: fp.strSiglasUnidad.trim() === 'FCSH' ? "#000000" : "#ffffffff" }} /> : <Iconify icon={"ic:baseline-expand-more"} width={30} sx={{ color: fp.strSiglasUnidad.trim() === 'FCSH' ? "#000000" : "#ffffffff" }} />}
                      </IconButton>
                    </Box>
                    <Grid sx={{ pl: 2 }}>
                      {NietoDelProdigoPost(fp)}
                    </Grid>
                  </>
                ))}
              </div>
            </Collapse>
          </>
        );
        break;
      default:
        collapseContent = (
          <Collapse
            in={audienciasCollapse.includes(padre.idAudiencia)}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              {hijos.map((hijo) => (
                <Box
                  key={hijo.idAudiencia}
                  display="flex"
                  alignItems="center"
                  sx={{
                    border: "1px solid " + InstitucionalPalette.SECONDARY,
                    backgroundColor: InstitucionalPalette.SECONDARY,
                    borderRadius: "6px",
                    padding: "4px 8px",
                    margin: "2px 0",
                    minHeight: "50px",
                  }}
                >
                  <Checkbox
                    checked={formik.values.audiencias.includes(hijo.idAudiencia)}
                    onChange={(e) => handleChildChange(hijo.idAudiencia, e.target.checked, hijo.idAudienciaPadre, audiencia.filter(a => a.idAudienciaPadre === hijo.idAudienciaPadre))}
                    sx={{
                      color: "#FFFFFF",
                      "&.Mui-checked": { color: "#FFFFFF" },
                      "& .MuiSvgIcon-root": { fontSize: 28 },
                      marginRight: "12px",
                      flexShrink: 0,
                    }}
                  />
                  <Typography
                    sx={{
                      color: "#FFFFFF",
                      flex: 1,                 // ocupa el espacio restante
                      textAlign: "left",       // alineación a la izquierda
                      whiteSpace: "normal",    // permite varias líneas
                      overflowWrap: "normal",  // evita cortar palabras
                    }}
                  >
                    {hijo.txNombre}
                  </Typography>
                </Box>
              ))}
            </div>
          </Collapse>
        );
        break;
    }
    return collapseContent;
  }

  const NietoDelProdigo = (facultad: Facultad) => {
    let collapseContent;
    collapseContent = (
      <>
        <Collapse
          in={gradoCollapse.includes(facultad.idUnidad)}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            {facultad.listaProgramas.sort((a, b) =>
              a.nombrePrograma.localeCompare(b.nombrePrograma)
            ).map((prog) => (
              <>
                <Box
                  key={"prog-" + prog.idPrograma}
                  display="flex"
                  alignItems="center"
                  sx={{
                    border: `1px solid ${getFacultadColor(facultad.siglasFacultad)}`,
                    backgroundColor: getFacultadColor(facultad.siglasFacultad),
                    borderRadius: "6px",
                    padding: "4px 8px",
                    margin: "2px 0",
                  }}
                >
                  <Checkbox
                    checked={formik.values.programasGrado.includes(
                      facultad.idUnidad + "-" + prog.idPrograma.toString()
                    )}
                    onChange={(e) =>
                      handleChildProgramaGradoChange(
                        facultad.idUnidad + "-" + prog.idPrograma.toString(),
                        e.target.checked
                      )
                    }
                    sx={{
                      color: facultad.siglasFacultad.trim() === "FCSH" ? "#000000" : "#FFFFFF",
                      "&.Mui-checked": {
                        color: facultad.siglasFacultad.trim() === "FCSH" ? "#000000" : "#FFFFFF",
                      },
                      "& .MuiSvgIcon-root": { fontSize: 28 },
                      marginRight: "8px",
                    }}
                  />

                  <Typography
                    sx={{
                      color: facultad.siglasFacultad.trim() === "FCSH" ? "#000000" : "#FFFFFF",
                      flex: 1,
                      textAlign: "left",
                      whiteSpace: "normal",   // permite varias líneas
                      wordBreak: "keep-all",  // no corta palabras
                      lineHeight: "1.4",      // mejora alineación vertical
                    }}
                  >
                    {prog.modalidad === 'Presencial' ? prog.nombrePrograma : `${prog.nombrePrograma} ${prog.modalidad}`}
                  </Typography>
                </Box>
              </>
            ))}
          </div>
        </Collapse>
      </>
    );
    return collapseContent;
  }

  const NietoDelProdigoPost = (facultad: FacultadPos) => {
    let collapseContent;
    collapseContent = (
      <>
        <Collapse
          in={postgradoCollapse.includes(facultad.idUnidad)}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            {facultad.lProgramas.sort((a, b) =>
              a.strNombre.localeCompare(b.strNombre)
            ).map((prog) => (
              <Box
                key={"prog-" + prog.id}
                display="flex"
                alignItems="center"
                sx={{
                  border: `1px solid ${facultad.strColorUnidad}`,
                  backgroundColor: facultad.strColorUnidad,
                  borderRadius: "6px",
                  padding: "4px 8px",
                  margin: "2px 0",
                }}
              >
                <Checkbox
                  checked={formik.values.programasPostGrado.includes(
                    facultad.idUnidad + "-" + prog.id.toString()
                  )}
                  onChange={(e) =>
                    handleChildProgramaPostGradoChange(
                      facultad.idUnidad + "-" + prog.id.toString(),
                      e.target.checked
                    )
                  }
                  sx={{
                    color: facultad.strSiglasUnidad.trim() === "FCSH" ? "#000000" : "#FFFFFF",
                    "&.Mui-checked": {
                      color: facultad.strSiglasUnidad.trim() === "FCSH" ? "#000000" : "#FFFFFF",
                    },
                    "& .MuiSvgIcon-root": { fontSize: 28 },
                    marginRight: "8px",
                  }}
                />

                <Typography
                  sx={{
                    color: facultad.strSiglasUnidad.trim() === "FCSH" ? "#000000" : "#FFFFFF",
                    flex: 1,
                    textAlign: "left",
                    whiteSpace: "normal",   // permite varias líneas
                    wordBreak: "keep-all",  // no corta palabras
                    lineHeight: "1.4",      // mejora alineación vertical
                  }}
                >
                  {prog.strNombre}
                </Typography>
              </Box>
            ))}
          </div>
        </Collapse>

      </>
    );
    return collapseContent;
  }

  return (
    <form onSubmit={formik.handleSubmit}>
      <Grid container direction={'row'} spacing={1}>
        <Grid item xs={12} sm={12} md={12}>
          <Box display="flex" justifyContent="center" alignItems="center" width="100%">
            <FormControl error={Boolean(formik.errors.bdTipo && formik.touched.bdTipo)}>
              <RadioGroup
                row
                aria-label="bdTipo"
                name="bdTipo"
                value={formik.values.bdTipo}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              >
                <FormControlLabel value="E" control={<Radio />} label="Evento" />
                <FormControlLabel value="A" control={<Radio />} label="Anuncio" />
              </RadioGroup>
              {formik.touched.bdTipo && formik.errors.bdTipo && (
                <Alert severity="error">{formik.errors.bdTipo}</Alert>
              )}
            </FormControl>
          </Box>
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <FormControl fullWidth error={Boolean(formik.errors.idArea && formik.touched.idArea)}>
            <InputLabel htmlFor="select-areas">Área</InputLabel>
            <Select
              labelId="select-areas"
              id="idArea"
              name="idArea"
              value={formik.values.idArea}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              label="Área"
              sx={{ marginBottom: '20px', width: '100%' }}
            >
              {area.map((a) => (
                <MenuItem key={a.idArea} value={a.idArea}>
                  {a.txNombreArea}
                </MenuItem>
              ))
              }
              <MenuItem value={0}>Seleccione un área</MenuItem>
            </Select>
            {formik.touched.idArea && formik.errors.idArea && (
              <Alert severity="error">{formik.errors.idArea}</Alert>
            )}
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <FormControl fullWidth error={formik.touched.categorias && Boolean(formik.errors.categorias)}>
            <Autocomplete
              multiple
              options={categoria}
              value={formik.values.categorias} // Mantén el valor en el estado de Formik
              getOptionLabel={(option) => option.txNombreCategoria} // Muestra el nombre del tag
              isOptionEqualToValue={(option, value) => option.idCategoria === value.idCategoria} // Comparar por ID de tag
              onChange={(_, newValue) => {
                formik.setFieldValue("categorias", newValue); // Actualiza el valor en Formik
              }}
              onBlur={() => formik.setFieldTouched("categorias", true)}
              renderInput={(params) => (
                <TextField {...params} label="Seleccionar Categoría" />
              )}
              renderOption={(props, option) => (
                <Tooltip key={'cat-' + option.idCategoria} title={option.txtDescripcion} placement="top" arrow>
                  <li {...props}>{option.txNombreCategoria}</li>
                </Tooltip>
              )}
            />
            {formik.touched.categorias && typeof formik.errors.categorias === "string" && (
              <Alert severity="error">{formik.errors.categorias}</Alert>
            )}
          </FormControl>
        </Grid>
        {formik.values.bdTipo === 'E' && (
          <Grid item xs={12} sm={12} md={6}>
            <FormControl fullWidth error={Boolean(formik.errors.idTipoEvento && formik.touched.idTipoEvento)}>
              <InputLabel htmlFor="select-tipo-evento">Tipo Evento</InputLabel>
              <Select
                labelId="select-tipo-evento"
                id="idTipoEvento"
                name="idTipoEvento"
                value={formik.values.idTipoEvento}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                label="Tipo Evento"
                sx={{ marginBottom: '20px', width: '100%' }}
              >
                {tipoEvento.map((c) => (
                  <MenuItem key={"tipo-" + c.idTipoEvento} value={c.idTipoEvento}>
                    <Tooltip title={c.txtDescripcion} placement="top" arrow>
                      <span>{c.txtNombre}</span>
                    </Tooltip>
                  </MenuItem>
                ))
                }
                <MenuItem value={0}>Seleccione un tipo de evento</MenuItem>
              </Select>
              {formik.touched.idTipoEvento && formik.errors.idTipoEvento && (
                <Alert severity="error">{formik.errors.idTipoEvento}</Alert>
              )}
            </FormControl>
          </Grid>
        )}
        <Grid item xs={12}>
          <Box display="flex" alignItems="center">
            {/* Texto fijo a la izquierda */}
            <FormLabel
              component="legend"
              sx={{
                ml: 1,
                mr: 2,
                whiteSpace: "nowrap",
                color: InstitucionalPalette.PRIMARY,
                fontWeight: "bold",
              }}
            >
              Dirigido a:
            </FormLabel>
            {/* Switch con su propio label */}
            <FormControlLabel
              control={
                <Switch
                  color="primary"
                  checked={formik.values.audiencias.includes(17)} // estado booleano
                  onChange={handleSwitchChange} // cambia el estado
                />
              }
              label="Público general"
              sx={{
                ml: 1,
                color: InstitucionalPalette.PRIMARY,
                "& .MuiFormControlLabel-label": {
                  fontWeight: "medium",
                },
              }}
            />
          </Box>
        </Grid>
        {!formik.values.audiencias.includes(17) ?
          <Grid item xs={12}>
            <Box display="flex" alignItems="flex-start" >
              {/* Contenedor centrado */}
              <Box flex={1} display="flex" justifyContent="center">
                <FormGroup row sx={{ flexWrap: "wrap" }}>
                  <div style={{
                    display: "flex",
                    gap: "20px",
                    overflowX: "auto",
                    whiteSpace: "nowrap",
                    paddingBottom: "10px",
                    padding: "0 10px 10px 10px"
                  }}>
                    {audiencia
                      .filter((x) => x.idAudienciaPadre === null && x.idAudiencia !== 17)
                      .map((padre) => {
                        const hijos = audiencia.filter((a) => a.idAudienciaPadre === padre.idAudiencia);
                        const hijosSeleccionados = hijos.filter((h) =>
                          formik.values.audiencias.includes(h.idAudiencia)
                        );

                        // Total y seleccionados dependiendo del tipo de padre
                        let total = hijos.length;
                        let seleccionados = hijosSeleccionados.length;

                        if (padre.idAudiencia === 3) {
                          total = carrerasGrado.length;
                          seleccionados = formik.values.facultadesGrado.length;
                        } else if (padre.idAudiencia === 6) {
                          total = carrerasPostGrado.length;
                          seleccionados = formik.values.facultadesPostGrado.length;
                        }

                        // Estados del checkbox
                        const allChildrenChecked = total > 0 && seleccionados === total;
                        const someChildrenChecked = seleccionados > 0 && seleccionados < total;
                        return (
                          <div
                            key={padre.idAudiencia}
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            {/* Checkbox padre */}
                            <Box
                              key={"padre-" + padre.idAudiencia}
                              display="flex"
                              alignItems="center"
                              sx={{
                                border: "2px solid " + InstitucionalPalette.THIRD,
                                backgroundColor: InstitucionalPalette.THIRD,
                                borderRadius: "8px",
                                padding: "4px 4px",
                                marginBottom: "8px",
                                "& .MuiFormControlLabel-label": {
                                  fontWeight: "bold",
                                  color: "#ffffff",
                                },
                              }}
                            >
                              <Checkbox
                                checked={formik.values.audiencias.includes(padre.idAudiencia) || allChildrenChecked}
                                indeterminate={!!someChildrenChecked}
                                onChange={(e) => {
                                  handleParentChange(padre, e.target.checked, hijos);
                                }}
                                sx={{
                                  color: "#ffffffff", // color del ícono cuando no está marcado
                                  "&.Mui-checked": {
                                    color: "#ffffffff", // color cuando está marcado (ej: verde contraste)
                                  },
                                  "&.MuiCheckbox-indeterminate": {
                                    color: "#ffffff",
                                  },
                                  "& .MuiSvgIcon-root": {
                                    fontSize: 28, // opcional, cambiar tamaño
                                  },
                                }}
                              />
                              <Typography
                                sx={{
                                  color: "#FFFFFF",
                                  flex: 1,
                                  textAlign: "left",
                                  whiteSpace: "normal",   // permite varias líneas
                                  wordBreak: "keep-all",  // no corta palabras
                                  lineHeight: "1.4",      // mejora alineación vertical
                                }}
                              >
                                {padre.txNombre}
                              </Typography>
                              <IconButton
                                size="small"
                                onClick={() => toggleAudienciaCollapse(padre.idAudiencia)}
                                sx={{
                                  color: "#fff",
                                  transition: "transform 0.3s",
                                }}
                              >
                                {audienciasCollapse.includes(padre.idAudiencia) ? <Iconify icon={"ic:outline-expand-less"} width={30} sx={{ color: 'white' }} /> : <Iconify icon={"ic:baseline-expand-more"} width={30} sx={{ color: 'white' }} />}
                              </IconButton>
                            </Box>
                            {HijoProdigo(padre, hijos)}
                          </div>
                        );
                      })}
                  </div>
                </FormGroup>
              </Box>
            </Box>
            {/* Validación de errores */}
            {formik.touched.audiencias && formik.errors.audiencias && (
              <Alert severity="error">{formik.errors.audiencias}</Alert>
            )}
          </Grid>
          : <></>}
        <Grid item xs={12} sm={12} md={6}>
          <FormControl
            fullWidth
            error={Boolean(formik.errors.txTitulo && formik.touched.txTitulo)}
          >
            <TextField
              fullWidth
              id="txTitulo"
              name="txTitulo"
              label="Título"
              value={formik.values.txTitulo}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.txTitulo && Boolean(formik.errors.txTitulo)}
              sx={{ marginBottom: '20px', width: '100%' }}
            />
            {formik.touched.txTitulo && formik.errors.txTitulo && (
              <Alert severity="error">{formik.errors.txTitulo}</Alert>
            )}
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <FormControl
            fullWidth
            error={Boolean(formik.errors.txUrl && formik.touched.txUrl)}
          >
            <TextField
              fullWidth
              id="txUrl"
              name="txUrl"
              label="URL/Enlace"
              value={formik.values.txUrl}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.txUrl && Boolean(formik.errors.txUrl)}
              sx={{ marginBottom: '20px', width: '100%' }}
            />
            {formik.touched.txUrl && formik.errors.txUrl && (
              <Alert severity="error">{formik.errors.txUrl}</Alert>
            )}
          </FormControl>
        </Grid>
        {formik.values.bdTipo === 'E' && (
          <>
            <Grid item xs={12} sm={12} md={12}>
              <FormControlLabel
                name="esEnEspol"
                control={<Checkbox
                  checked={formik.values.esEnEspol}
                  onChange={formik.handleChange}
                />}
                label='¿El evento es en Espol?'
              />
            </Grid>
            {formik.values.esEnEspol ?
              <>
                <Grid item xs={12} sm={12} md={6}>
                  <FormControl fullWidth error={Boolean(formik.errors.idCampus && formik.touched.idCampus)}>
                    <InputLabel htmlFor="select-campus">Campus</InputLabel>
                    <Select
                      labelId="select-campus"
                      id="idCampus"
                      name="idCampus"
                      value={formik.values.idCampus}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      label="Campus"
                      sx={{ marginBottom: '20px', width: '100%' }}
                    >
                      {campus.map((c) => (
                        <MenuItem key={"campus-" + c.idlugarespol} value={c.idlugarespol}>
                          {c.descripcion}
                        </MenuItem>
                      ))
                      }
                      <MenuItem value={0}>Seleccione un Campus</MenuItem>
                    </Select>
                    {formik.touched.idCampus && formik.errors.idCampus && (
                      <Alert severity="error">{formik.errors.idCampus}</Alert>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <FormControl fullWidth error={Boolean(formik.errors.idZona && formik.touched.idZona)}>
                    <InputLabel htmlFor="select-zona">Zona</InputLabel>
                    <Select
                      labelId="select-zona"
                      id="idZona"
                      name="idZona"
                      value={formik.values.idZona}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      label="Zona"
                      sx={{ marginBottom: '20px', width: '100%' }}
                    >
                      {zonas.map((c) => (
                        <MenuItem key={"zona-" + c.idifzona} value={c.idifzona}>
                          {c.referencia}
                        </MenuItem>
                      ))
                      }
                      <MenuItem value={0}>Seleccione una Zona</MenuItem>
                    </Select>
                    {formik.touched.idZona && formik.errors.idZona && (
                      <Alert severity="error">{formik.errors.idZona}</Alert>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <FormControl fullWidth error={Boolean(formik.errors.idBloque && formik.touched.idBloque)}>
                    <InputLabel htmlFor="select-bloque">Bloque</InputLabel>
                    <Select
                      labelId="select-bloque"
                      id="idBloque"
                      name="idBloque"
                      value={formik.values.idBloque}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      label="Bloque"
                      sx={{ marginBottom: '20px', width: '100%' }}
                    >
                      {bloques.map((c) => (
                        <MenuItem key={"bloque-" + c.id} value={c.id}>
                          {c.descripcion === null ? c.codigo : `${c.codigo}-${c.descripcion}`}
                        </MenuItem>
                      ))
                      }
                      <MenuItem value={0}>Seleccione un Bloque</MenuItem>
                    </Select>
                    {formik.touched.idBloque && formik.errors.idBloque && (
                      <Alert severity="error">{formik.errors.idBloque}</Alert>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <FormControl fullWidth error={Boolean(formik.errors.idTipoUbicacion && formik.touched.idTipoUbicacion)}>
                    <InputLabel htmlFor="select-tipoubi">Tipo Ubicación</InputLabel>
                    <Select
                      labelId="select-tipoubi"
                      id="idTipoUbicacion"
                      name="idTipoUbicacion"
                      value={formik.values.idTipoUbicacion}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      label="Tipo Ubicación"
                      sx={{ marginBottom: '20px', width: '100%' }}
                    >
                      {tiposUbicaciones.map((c) => (
                        <MenuItem key={"tipoubi-" + c.idifgrupotipo} value={c.idifgrupotipo}>
                          {c.nombregrupotipo}
                        </MenuItem>
                      ))
                      }
                      <MenuItem value={0}>Seleccione un tipo</MenuItem>
                    </Select>
                    {formik.touched.idTipoUbicacion && formik.errors.idTipoUbicacion && (
                      <Alert severity="error">{formik.errors.idTipoUbicacion}</Alert>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl fullWidth error={Boolean(formik.errors.idUbicacion && formik.touched.idUbicacion)}>
                    <InputLabel htmlFor="select-ubi">Ubicación</InputLabel>
                    <Select
                      labelId="select-ubi"
                      id="idUbicacion"
                      name="idUbicacion"
                      value={formik.values.idUbicacion}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      label="Ubicación"
                      sx={{ marginBottom: '20px', width: '100%' }}
                    >
                      {ubicaciones.map((c) => (
                        <MenuItem key={"ubi-" + c.idifsubgrupo} value={c.idifsubgrupo}>
                          {`${c.nombregrupotipo}-${c.etiqueta}`}
                        </MenuItem>
                      ))
                      }
                      <MenuItem value={0}>Seleccione Ubicación</MenuItem>
                    </Select>
                    {formik.touched.idUbicacion && formik.errors.idUbicacion && (
                      <Alert severity="error">{formik.errors.idUbicacion}</Alert>
                    )}
                  </FormControl>
                </Grid>
              </>
              : <>
                <Grid item xs={12} sm={12} md={6}>
                  <FormControl fullWidth error={Boolean(formik.errors.txLugar && formik.touched.txLugar)}>
                    <TextField
                      fullWidth
                      id="txLugar"
                      name="txLugar"
                      label="Lugar"
                      value={formik.values.txLugar}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={formik.touched.txLugar && Boolean(formik.errors.txLugar)}
                      sx={{ marginBottom: '20px', width: '100%' }}
                    />
                    {formik.touched.txLugar && formik.errors.txLugar && (
                      <Alert severity="error">{formik.errors.txLugar}</Alert>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <FormControl fullWidth error={Boolean(formik.errors.txtUrlMaps && formik.touched.txtUrlMaps)}>
                    <TextField
                      fullWidth
                      id="txtUrlMaps"
                      name="txtUrlMaps"
                      label="Enlace Mapa"
                      value={formik.values.txtUrlMaps}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={formik.touched.txtUrlMaps && Boolean(formik.errors.txtUrlMaps)}
                      sx={{ marginBottom: '20px', width: '100%' }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton color="primary" onClick={handleOpen}>
                              <FaMap />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                    {formik.touched.txtUrlMaps && formik.errors.txtUrlMaps && (
                      <Alert severity="error">{formik.errors.txtUrlMaps}</Alert>
                    )}
                  </FormControl>
                </Grid>
              </>
            }
          </>
        )}
        {formik.values.bdTipo === 'E' && (
          <>
            <Grid item xs={12} sm={12} md={6}>
              <FormControl fullWidth error={Boolean(formik.errors.dtInicio && formik.touched.dtInicio)}>
                <TextField
                  id="dtInicio"
                  type="datetime-local"
                  name="dtInicio"
                  label="Fecha y Hora de Inicio de Evento"
                  value={formik.values.dtInicio}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  sx={{ marginBottom: '20px', width: '100%' }}
                  InputLabelProps={{
                    shrink: true, // Asegura que el label no se superponga al valor
                  }}
                />
                {formik.touched.dtInicio && formik.errors.dtInicio && (
                  <Alert severity="error">{formik.errors.dtInicio}</Alert>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <FormControl fullWidth error={formik.touched.dtFin && Boolean(formik.errors.dtFin)}>
                <TextField
                  id="dtFin"
                  type="datetime-local"
                  name="dtFin"
                  label="Fecha y Hora de Fin de Evento"
                  value={formik.values.dtFin}
                  sx={{ marginBottom: '20px', width: '100%' }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  InputLabelProps={{
                    shrink: true, // Asegura que el label no se superponga al valor
                  }}
                />
                {formik.touched.dtFin && formik.errors.dtFin && (
                  <Alert severity="error">{formik.errors.dtFin}</Alert>
                )}
              </FormControl>
            </Grid>
          </>
        )}
        <Grid item xs={12} sm={12} md={6}>
          <FormControl fullWidth error={formik.touched.dtPublicacion && Boolean(formik.errors.dtPublicacion)}>
            <TextField
              id="dtPublicacion"
              type="date"
              name="dtPublicacion"
              label="Fecha de publicación"
              value={textDateFormat(formik.values.dtPublicacion)}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              sx={{ marginBottom: '20px', width: '100%' }}
              InputLabelProps={{
                shrink: true, // Asegura que el label no se superponga al valor
              }}
              InputProps={{
                readOnly: formik.values.bdPublicarAutomatico, // Si el checkbox está seleccionado, el campo es de solo lectura
              }}
            />
            {formik.touched.dtPublicacion && formik.errors.dtPublicacion && (
              <Alert severity="error">{formik.errors.dtPublicacion}</Alert>
            )}
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <FormControlLabel
            control={
              <Checkbox
                checked={formik.values.bdPublicarAutomatico}
                onChange={handleCheckboxChange}
                name="bdPublicarAutomatico"
              />
            }
            label="Publicación Automática"
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <FormControl fullWidth error={formik.touched.dtVigencia && Boolean(formik.errors.dtVigencia)}>
            <TextField
              id="dtVigencia"
              type="date"
              name="dtVigencia"
              label="Vigencia"
              value={textDateFormat(formik.values.dtVigencia)}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              sx={{ marginBottom: '20px', width: '100%' }}
              InputLabelProps={{
                shrink: true, // Asegura que el label no se superponga al valor
              }}
            />
            {formik.touched.dtVigencia && formik.errors.dtVigencia && (
              <Alert severity="error">{formik.errors.dtVigencia}</Alert>
            )}
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <Box display="flex" alignItems="center">
            <FormLabel component="legend"
              style={{ marginLeft: '10px', marginRight: '16px' }}>Ámbito</FormLabel>
            <FormControl error={formik.touched.bdAmbito && Boolean(formik.errors.bdAmbito)}>
              <RadioGroup
                row
                aria-label="bdAmbito"
                name="bdAmbito"
                value={formik.values.bdAmbito}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              >
                <FormControlLabel value="I" control={<Radio />} label="Interno" />
                <FormControlLabel value="A" control={<Radio />} label="Abierto" />
              </RadioGroup>
              {formik.touched.bdAmbito && formik.errors.bdAmbito && (
                <Alert severity="error">{formik.errors.bdAmbito}</Alert>
              )}
            </FormControl>
          </Box>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <FormControl fullWidth error={formik.touched.txTexto && Boolean(formik.errors.txTexto)}>
            <TextField
              fullWidth
              multiline
              rows={3}
              id="txTexto"
              name="txTexto"
              label="Descripción"
              value={formik.values.txTexto}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              sx={{ marginBottom: '20px', width: '100%' }}
            />
            {formik.touched.txTexto && formik.errors.txTexto && (
              <Alert severity="error">{formik.errors.txTexto}</Alert>
            )}
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <FormControl fullWidth error={formik.touched.txTexto && Boolean(formik.errors.txTexto)}>
            <Autocomplete
              multiple
              options={tags}
              value={formik.values.tematicas} // Mantén el valor en el estado de Formik
              getOptionLabel={(option) => option.txtNombre} // Muestra el nombre del tag
              isOptionEqualToValue={(option, value) => option.idTematica === value.idTematica} // Comparar por ID de tag
              onChange={(_, newValue) => {
                // `newValue` contendrá los objetos seleccionados
                formik.setFieldValue("tematicas", newValue); // Actualiza el valor en Formik
              }}
              onBlur={formik.handleBlur} // Para manejar el blur si lo necesitas
              renderInput={(params) => (
                <TextField {...params} label="Seleccionar Tags" />
              )}
              renderOption={(props, option) => (
                <Tooltip title={option.txtDescripcion} placement="top" arrow>
                  <li {...props}>{option.txtNombre}</li>
                </Tooltip>
              )}
            />
          </FormControl>
        </Grid>
        {(formik.values.txImagen || formik.values.Imagen) && (
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            container
            justifyContent="center"
            alignItems="center"
            sx={{ display: 'flex' }}
          >
            <ImagePreviewer
              image={formik.values.Imagen ? URL.createObjectURL(formik.values.Imagen) : formik.values.txImagen}
              maxWidth="300px"
            />
          </Grid>
        )}
        <Grid item xs={12} sm={12} md={12}>
          <FormLabel component="legend">Arte del comunicado en formato .jpg tamaño 1200px x 1200px con peso máximo de 1MB.</FormLabel>
          <FormControl fullWidth error={formik.touched.Imagen && Boolean(formik.errors.Imagen)}>
            <Button variant="contained" component="label" sx={{ width: '100%' }}>
              Seleccionar Imagen
              <input
                id="Imagen"
                name="Imagen"
                type="file"
                accept="image/jpg"
                onChange={(event) => {
                  const file = event.currentTarget.files ? event.currentTarget.files[0] : null;
                  if (file) {
                    formik.setFieldValue('Imagen', file);
                  }
                }}
                hidden // Ocultar el input
              />
            </Button>
            {formik.touched.Imagen && formik.errors.Imagen && (
              <Alert severity="error">{formik.errors.Imagen}</Alert>
            )}
            {/* Mostrar el nombre del archivo si está seleccionado */}
            {formik.values.Imagen && formik.values.Imagen.name && (
              <Typography variant="body2" sx={{ marginTop: '10px', color: 'text.secondary' }}>
                {formik.values.Imagen.name}
              </Typography>
            )}
          </FormControl>
        </Grid>
        {formik.values.bdTipo === 'E' && (
          <>
            {(formik.values.txtImagenCaratula || formik.values.ImagenCaratula) && (
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                container
                justifyContent="center"
                alignItems="center"
                sx={{ display: 'flex' }}
              >
                <ImagePreviewer
                  image={formik.values.ImagenCaratula ? URL.createObjectURL(formik.values.ImagenCaratula) : formik.values.txtImagenCaratula}
                  maxWidth="300px"
                />
              </Grid>
            )}
            {/* Campo Imagen Carátula */}
            <Grid item xs={12} sm={12} md={12}>
              <FormLabel component="legend">Carátula Evento con formato .webp y debe ser solo una imagen (sin texto) tamaño 640px x 410px con peso máximo de 1MB.</FormLabel>
              <FormControl fullWidth error={formik.touched.ImagenCaratula && Boolean(formik.errors.ImagenCaratula)}>
                <Button variant="contained" component="label" color="secondary" sx={{ width: '100%' }}>
                  Seleccionar Carátula
                  <input
                    id="ImagenCaratula"
                    name="ImagenCaratula"
                    type="file"
                    accept="image/webp"
                    onChange={(event) => {
                      const file = event.currentTarget.files ? event.currentTarget.files[0] : null;
                      if (file) {
                        formik.setFieldValue('ImagenCaratula', file);
                      }
                    }}
                    hidden // Ocultar el input
                  />
                </Button>
                {formik.touched.ImagenCaratula && formik.errors.ImagenCaratula && (
                  <Alert severity="error">{formik.errors.ImagenCaratula}</Alert>
                )}
                {/* Mostrar el nombre del archivo si está seleccionado */}
                {formik.values.ImagenCaratula && formik.values.ImagenCaratula.name && (
                  <Typography variant="body2" sx={{ marginTop: '10px', color: 'text.secondary' }}>
                    {formik.values.ImagenCaratula.name}
                  </Typography>
                )}
              </FormControl>
            </Grid>
          </>
        )}
        <Grid item xs={12} sm={12} md={6}>
          <Button
            style={{ width: '50%', borderRadius: '25px' }}
            variant="contained"
            type="submit"  // Cambiar de 'submit' a 'button'
            onClick={() => {
              formik.setFieldValue('bdEstado', 'P'); // Establecer como pendiente
            }}
          >
            Enviar a Aprobación
          </Button>
        </Grid>
        {/* <Button style={{ backgroundColor: '#ccc', color: 'black', width: '50%', borderRadius: '25px' }}
            onClick={() => {
              console.log(formik.errors)
              console.log(formik.values)
            }}
          >
            error
          </Button> */}
        <Grid item xs={12} sm={12} md={6}>
          <Button
            style={{ backgroundColor: '#ccc', color: 'black', width: '50%', borderRadius: '25px' }}
            variant="contained"
            type="submit"  // Cambiar de 'submit' a 'button'
            onClick={() => {
              formik.setFieldValue('bdEstado', 'B'); // Establecer como borrador
            }}
          >
            Guardar como Borrador
          </Button>
        </Grid>

      </Grid>
      <Dialog
        open={openMap}
        onClose={handleClose}
        maxWidth="sm" // Cambia a 'xs', 'sm', 'lg', etc.
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">
          Link de Mapa
        </DialogTitle>
        <DialogContent>
          <InfoMapa />
        </DialogContent>
        <DialogActions>
          <Button variant='contained' onClick={() => handleOpenLink(enlace)} endIcon={<FaMap />}>
            Abrir Google Maps
          </Button>
        </DialogActions>
      </Dialog>
    </form>
  );
};